import React from "react"
import Layout from "../components/Layout"
import { graphql } from "gatsby"
import Title from "../components/Title"
import SocialLinks from "../constants/socialLinks"
import SEO from "../components/SEO"


const About = ({
  data: {
    allStrapiAbout: { nodes },
  },
}) => {
 const {title, info, skills} = nodes[0]
  return <Layout>
    <SEO title="About" description="About AKHADAM AYOUB" />
    <section className="about-page">
      <div className="section-center about-center">
       {/* <Image fluid={image.childImageSharp.fluid} className="about-img" /> **/}
        <article className="about-text">
          <Title title={title} />
          <p>{info}</p>
          <div className="about-stack">
            {
              skills.map((skill) => {
                return <span key={skill.id}>{skill.name}</span>
              })
            }
          </div>
          <div>
            <SocialLinks />
          </div>
        </article>
        <div>
        </div>
      </div>
    </section>
  </Layout>
}

export default About
export const query = graphql`
{
  allStrapiAbout {
    nodes {
      title
      info
      skills {
        id
        name
      }
    }
  }
}
`
